export interface ClientAccessInfoDto {
    HasAccess: boolean;
    ClientName: string;
    EntityName: string;
    ReportingGroupName?: string;
    Month: number;
    Year: number;
    ApplicationUrl: string;
    IsEntityLocked: boolean;
}

export interface ClientAccessInfoResponseDto {
  Success: boolean;
  Value: string;
  Data?: ClientAccessInfoDto | null;
}